import ContextMenu from './ContextMenu';

export default ContextMenu;
export type { IContextMenuProps } from './ContextMenu';
export { useContextMenu } from './useContextMenu';
export { elementMenuPoint, isContextMenuKey } from './contextMenuTrigger';
export type { ContextMenuTriggerEvent } from './contextMenuTrigger';
